<template>
  <div class="profile-page">
    <b-row>
      <b-col cols="12">
        <h3>Profile Details</h3>
      </b-col>
    </b-row>
    <b-row class="content-wrapper">
      <!-- Sidebar - on top for small/mobile, left for medium+ -->
      <b-col
        cols="12"
        md="3"
        class="sidebar-wrapper"
      >
        <div class="sidebar-content">
          <profile />
        </div>
      </b-col>
      <!-- Scrollable content - below sidebar on small/mobile, right on medium+ -->
      <b-col
        ref="scrollableContent"
        cols="12"
        md="9"
        class="scrollable-content"
      >
        <router-view></router-view>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import profile from "@/components/profile/profileCategory";
export default {
  components: {
    profile,
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        setTimeout(() => this.scrollContentIntoView(), 100);
      });
    },
  },
  methods: {
    scrollContentIntoView() {
      if (window.innerWidth >= 768) return;
      const el = this.$refs.scrollableContent;
      if (el) {
        const rect = el.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetTop = rect.top + scrollTop;
        window.scrollTo({ top: targetTop - 10, behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
.profile-page {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.content-wrapper {
  flex: 1;
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
}

/* Medium+ (768px+): side-by-side layout */
@media (min-width: 768px) {
  .content-wrapper {
    flex-wrap: nowrap;
  }
}

.sidebar-wrapper {
  overflow-y: auto;
}

.sidebar-wrapper::-webkit-scrollbar {
  width: 8px;
}

.sidebar-wrapper::-webkit-scrollbar-thumb {
  background-color: #bbb;
  border-radius: 4px;
}

.scrollable-content {
  overflow-y: auto;
}

/* Small and mobile: sidebar on top, content below */
@media (max-width: 767.98px) {
  .content-wrapper {
    flex-direction: column;
  }

  .sidebar-wrapper {
    max-height: none;
    order: 1;
    flex: 0 0 auto;
    width: 100%;
  }

  .scrollable-content {
    order: 2;
    flex: 1 1 auto;
    min-height: 0;
  }
}

/* Medium (768px–991px): sidebar left, content right */
@media (min-width: 768px) and (max-width: 991.98px) {
  .sidebar-wrapper {
    max-height: 80vh;
  }

  .scrollable-content {
    height: 100%;
  }
}

/* Large (992px+): full sidebar height */
@media (min-width: 992px) {
  .sidebar-wrapper {
    max-height: 90vh;
  }

  .scrollable-content {
    height: 100%;
  }
}
</style>
